// src/pages/Login.jsx
import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  console.log('🟢 Login.jsx component rendered');
  const { login, resetUserPassword, accessDenied } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [resetMessage, setResetMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setResetMessage('');
    try {
      await login(email, password);
      navigate('/dashboard');
    } catch (err) {
      // Use the specific error message from the auth system
      setError(err.message || 'Invalid email or password');
    }
  };

  const handleResetPassword = async () => {
    setError('');
    setResetMessage('');
    if (!email) {
      setError('Please enter your email address to reset your password.');
      return;
    }
    try {
      await resetUserPassword(email);
      setResetMessage('Password reset email sent. Please check your inbox.');
    } catch (err) {
      setError('Failed to send password reset email.');
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-4 rounded shadow-sm w-100"
        style={{ maxWidth: '400px' }}
      >
        <h2 className="h3 text-center mb-4">Sign In</h2>
        {(error || accessDenied) && (
          <div className={`alert ${accessDenied || error.includes('organisation no longer has access') ? 'alert-warning' : 'alert-danger'}`}>
            <strong>{accessDenied || error.includes('organisation no longer has access') ? '⚠️ Access Issue' : '❌ Login Failed'}</strong>
            <br />
            {accessDenied ? accessDenied.message : error}
          </div>
        )}
        {resetMessage && <div className="alert alert-success">{resetMessage}</div>}
        <div className="mb-3">
          <label className="form-label">Email</label>
          <input
            type="email"
            className="form-control"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            autoFocus
          />
        </div>
        <div className="mb-4">
          <label className="form-label">Password</label>
          <input
            type="password"
            className="form-control"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
        </div>
        <button
          type="submit"
          className="btn btn-primary w-100 mb-3"
        >
          Sign In
        </button>
        <button
          type="button"
          className="btn btn-secondary w-100 mb-3"
          onClick={() => {
            setEmail('demo@crisiscompass.com');
            setPassword('demo123');
          }}
        >
          Use Demo Account
        </button>
        <div className="text-end">
          <button
            type="button"
            className="btn btn-link p-0"
            onClick={handleResetPassword}
          >
            Forgot Password?
          </button>
        </div>
      </form>
    </div>
  );
}